import apiClient from '../../lib/axios';

export const fetchMonthlyFinancialProjection = async ({
  projectId,
  projectPeriodId,
  month,
  currencyView = 'TZS',
} = {}) => {
  const params = new URLSearchParams();
  if (projectId) params.append('projectId', projectId);
  if (projectPeriodId) params.append('projectPeriodId', projectPeriodId);
  if (month != null) params.append('month', String(month));
  if (currencyView) params.append('currencyView', currencyView);
  const { data } = await apiClient.get(`/api/financial-projections/monthly?${params.toString()}`);
  return data;
};

export const fetchFinancialProjectionDistribution = async ({
  projectId,
  projectPeriodId,
  currencyView = 'TZS',
} = {}) => {
  const params = new URLSearchParams();
  if (projectId) params.append('projectId', projectId);
  if (projectPeriodId) params.append('projectPeriodId', projectPeriodId);
  if (currencyView) params.append('currencyView', currencyView);
  const { data } = await apiClient.get(`/api/financial-projections/distribution?${params.toString()}`);
  return data;
};

export default {
  fetchMonthlyFinancialProjection,
  fetchFinancialProjectionDistribution,
};

